import * as tslib_1 from "tslib";
// CR28
import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import LoadingIndicator from '../../../LoadingIndicator';
import Button from '../../../Button';
import Flex from '../../../Flex';
import { ThemeOverride } from '../../../Context';
import { ThemeOptions } from '../../../publicSession/types';
import { IconSize } from '../../../Icons/IconWrap';
import BellIcon from '../../../Icons/Bell';
import BiButton from '../../../biLogger/Components/BiButton';
import SiteHeaderStyles from '../SiteHeader.scss';
import { withTranslation } from 'react-i18next';
import { BiLink } from '../../../biLogger';
import VerificationReminder from '../../_partials/VerificationReminder';
import s from './NotificationsDropdown.scss';
var NotificationsDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsDropdown, _super);
    function NotificationsDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: true,
            // flag used to ensure frame URL gets navigated to only once
            hasBeenOpened: false,
        };
        _this.handleOnLoad = function () {
            // note: this will fire if src is not yet set (or even when the src attribute is missing entirely)
            // so we wait until it's loading our src document to stop showing the loading indicator
            if (_this.props.isOpen || _this.state.hasBeenOpened) {
                _this.setState({ isLoading: false });
                if (typeof document !== 'undefined' &&
                    typeof window !== 'undefined' &&
                    window.location.host.indexOf('deviantart.com') !== -1) {
                    document.domain = 'deviantart.com';
                }
            }
        };
        return _this;
    }
    NotificationsDropdown.prototype.render = function () {
        var _a = this.props, verificationEmail = _a.verificationEmail, feedbackCount = _a.feedbackCount, isOpen = _a.isOpen, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onClick = _a.onClick, biData = _a.biData, href = _a.href, ariaLabel = _a["aria-label"];
        var _b = this.state, isLoading = _b.isLoading, hasBeenOpened = _b.hasBeenOpened;
        var notificationsUrl = Url.feedbackLink();
        // It's inaccessible to use a button if we only need to link somewhere.
        var BiComponent = onClick ? BiButton : BiLink;
        return (React.createElement("div", { className: SiteHeaderStyles['icon-button-has-submenu'], onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
            React.createElement(BiComponent, { biData: biData, className: classnames(SiteHeaderStyles['icon-button'], SiteHeaderStyles['bell-button'], isOpen && SiteHeaderStyles['active']), href: href, onClick: onClick, "aria-label": ariaLabel },
                React.createElement("span", null,
                    React.createElement(BellIcon, { className: SiteHeaderStyles['notifications-icon'], size: IconSize.MEDIUM }),
                    feedbackCount !== '0' && (React.createElement("span", { className: SiteHeaderStyles['number'] }, feedbackCount)))),
            React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT, className: classnames(s['container'], isOpen && s['active']) },
                React.createElement(Flex, { justifyContent: "space-between", alignItems: "center", className: s['title-container'] },
                    React.createElement("span", { className: s['title'] }, this.props.t('siteHeader.notificationsMenu.titleMobile')),
                    React.createElement(Button, { href: notificationsUrl, className: s['see-all'], target: "_top", view: "b33" }, this.props.t('siteHeader.notificationsMenu.seeAll'))),
                React.createElement("div", { className: s['separator'] }),
                React.createElement(Flex, { direction: "column", className: s['notifications-frame-wrapper'] },
                    !!verificationEmail && (React.createElement(VerificationReminder, { email: verificationEmail, hideChangeEmail: true })),
                    React.createElement("iframe", tslib_1.__assign({ title: "Eclipse notifications", id: "eclipse-notifications-iframe", className: s['notifications-frame'] }, ((isOpen || hasBeenOpened) && {
                        src: Url.notificationsHeaderLink(),
                    }), { frameBorder: "0", scrolling: this.state.isLoading ? 'no' : 'yes', onLoad: this.handleOnLoad }))),
                isLoading && (React.createElement(LoadingIndicator, { view: "spinner", className: s['loader'] })),
                React.createElement(Button, { href: notificationsUrl, className: s['footer-see-all'], target: "_top", view: "b81" }, this.props.t('siteHeader.notificationsMenu.seeAll')))));
    };
    NotificationsDropdown.prototype.componentDidUpdate = function (prevProps) {
        // this persists a state saying that the dropdown has been opened and the iframe does
        // (and should continue to have) a `src` attached to it
        if (!this.state.hasBeenOpened) {
            if (!prevProps.isOpen && this.props.isOpen) {
                this.setState({ hasBeenOpened: true });
            }
        }
    };
    return NotificationsDropdown;
}(React.Component));
export { NotificationsDropdown };
export default withTranslation()(NotificationsDropdown);
//# sourceMappingURL=NotificationsDropdown.js.map